import { appLinkTrees, PageLink } from "@megarax/links";

import { HttpUri } from "@megaron/http-uri";
import { getMegaraxPath, MegaraxUri } from "@megaron/megarax-uri";

import { navAccent } from "../nav/navConstants";

export const uriBase = (uri: string): string => uri.split("?")[0];

export const pinnedLinkHref = (uri: string): string => {
  if (MegaraxUri.isUri(uri)) return getMegaraxPath(uri);
  return uri;
};

export const isPinnedLinkExternal = (uri: string): boolean => HttpUri.isUri(uri);

type MatchedPageLink = {
  pageLink: PageLink;
  color: string;
};

export const matchPageLinkByUri = (uri: string): MatchedPageLink | undefined => {
  const base = uriBase(uri);

  for (const appTree of appLinkTrees) {
    const pageLink = appTree.pageLinks.find((link) => uriBase(link.uri) === base);
    if (pageLink) return { pageLink, color: appTree.color };
  }

  return undefined;
};

export const pinnedLinkColor = (uri: string): string => matchPageLinkByUri(uri)?.color ?? navAccent;
